import React, { useState, useEffect } from 'react';
import Modal from '@/components/common/Modal/Modal';
import coinsData from '@/utils/coins';
import styles from './ManageCoins.module.css';

/**
 * ManageCoins Component
 * Modal to manage which coins are visible in the wallet dropdown
 * Similar to SkylawWalletManage from old codebase
 */
const ManageCoins = ({ isOpen, onClose, onCoinsUpdated }) => {
  const [coins, setCoins] = useState([]);
  const [activeCoins, setActiveCoins] = useState([]);

  useEffect(() => {
    // Filter out SC and JPC from management (they shouldn't be toggled)
    const availableCoins = coinsData.filter(coin => 
      coin.preffix !== 'SC' && coin.preffix !== 'JPC' && coin.active
    );
    
    // Load active coins from storage
    const storedActiveCoins = localStorage.getItem('active_coins');
    const activeCoinIds = storedActiveCoins 
      ? storedActiveCoins.split(',').map(id => id.trim())
      : ['1', '2', '3', '4']; // Default active coins (BTC, INR, USDT, ETH)

    setCoins(availableCoins);
    setActiveCoins(activeCoinIds);
  }, []);

  const handleToggleCoin = (coinId) => {
    setActiveCoins(prev => {
      const isActive = prev.includes(coinId);
      let updated;
      
      if (isActive) {
        // Remove coin
        updated = prev.filter(id => id !== coinId);
      } else {
        // Add coin
        updated = [...prev, coinId];
      }

      // Ensure at least one coin is active (prefer BTC)
      if (updated.length === 0) {
        updated = ['1']; // Keep BTC active
      }
      
      // Ensure BTC is always included
      if (!updated.includes('1')) {
        updated.unshift('1');
      }

      // Save to storage
      localStorage.setItem('active_coins', updated.join(','));
      
      // Notify parent
      if (onCoinsUpdated) {
        onCoinsUpdated(updated);
      }

      return updated;
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      title="Manage Coins"
      showCloseButton={true}
    >
      <div className={styles.manageCoins}>
        <p className={styles.description}>
          Toggle coins to show or hide them in your wallet dropdown.
        </p>

        <div className={styles.coinList}>
          {coins.map((coin) => {
            const isActive = activeCoins.includes(coin.id.toString());
            return (
              <div key={coin.id} className={styles.coinItem}>
                <div className={styles.coinInfo}>
                  <img 
                    src={`/assets/images/coins/${coin.image}`} 
                    alt={coin.name}
                    className={styles.coinIcon}
                    onError={(e) => {
                      // Try .png if .webp fails
                      if (e.target.src.includes('.webp')) {
                        const pngPath = e.target.src.replace('.webp', '.png');
                        e.target.src = pngPath;
                      } else {
                        e.target.src = '/assets/images/coins/BTC.webp';
                      }
                    }}
                  />
                  <span className={styles.coinName}>{coin.preffix}</span>
                </div>
                
                <label className={styles.toggle}>
                  <input
                    type="checkbox"
                    checked={isActive}
                    onChange={() => handleToggleCoin(coin.id.toString())}
                    disabled={coin.id === 1} // BTC cannot be disabled
                  />
                  <span className={styles.slider} />
                </label>
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
};

export default ManageCoins;
